import layout from '../layout'
export default function makeCCRoutes({
  contentType,
  components: { CCListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list`,
          component: CCListingContainer,
          props: {
            contentType
          }
        }
      ]
    }
  ];
}
